export * from './configuracao';
export * from './caminho-imagem';
export * from '../enums/modo-salvar';
export * from './pode-excluir-inativar-base';
export * from './resultado-controller';
export * from './post-patch-com-string-dto';
